import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=7b82b3fe"
import script from "./banners.vue?vue&type=script&lang=js"
export * from "./banners.vue?vue&type=script&lang=js"
import style0 from "./banners.vue?vue&type=style&index=0&id=7b82b3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports